import KitoBalloon from '../../components/DataDisplay/Balloon';
import styles from './chatbubble.module.css';

const ChatBubble = ({img, text, outline, backgroundColor}) => {
  return (<div className={styles.chatRow}>
    <img className={styles.botImg} src={img} alt=""/>
    <KitoBalloon outline={outline} backgroundColor={backgroundColor}>
      {text}
    </KitoBalloon>
  </div>
  );
};

export default ChatBubble;